import { render, staticRenderFns } from "./HomeRouter.vue?vue&type=template&id=7b5cf414&scoped=true"
import script from "./HomeRouter.vue?vue&type=script&lang=js"
export * from "./HomeRouter.vue?vue&type=script&lang=js"
import style0 from "./HomeRouter.vue?vue&type=style&index=0&id=7b5cf414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cf414",
  null
  
)

export default component.exports